import idempotence from "../../idempotence";
import nodeListToArray from "../../nodeListToArray";
import ready from "../../ready";

const remoteOnlyToggle = {
  init() {
    // Handle search form "Remote only" checkbox
    nodeListToArray(
      document.querySelectorAll("[data-js-remote-only-toggle]")
    ).forEach((checkbox) => {
      this.initSearchItem(checkbox);
    });

    // Handle job post form "is_remote" checkbox
    nodeListToArray(
      document.querySelectorAll("[data-js-remote-toggle]")
    ).forEach((checkbox) => {
      this.initFormItem(checkbox);
    });
  },

  initSearchItem(checkbox) {
    if (idempotence.guard(checkbox, "remote-only-toggle")) return;

    const locationFields = checkbox
      .closest(".collapse")
      ?.querySelector("[data-js-location-fields]");

    if (!locationFields) return;

    checkbox.addEventListener("change", () => {
      if (checkbox.checked) {
        locationFields.classList.add("d-none");
      } else {
        locationFields.classList.remove("d-none");
      }
    });
  },

  initFormItem(checkbox) {
    if (idempotence.guard(checkbox, "remote-toggle")) return;

    // The location field div is the previous sibling of the checkbox's .form-check container
    const formCheck = checkbox.closest(".form-check");
    const locationField = formCheck?.previousElementSibling;

    if (!locationField?.hasAttribute("data-js-location-field")) return;

    checkbox.addEventListener("change", () => {
      if (checkbox.checked) {
        locationField.classList.add("d-none");
      } else {
        locationField.classList.remove("d-none");
      }
    });
  },
};

ready(() => {
  remoteOnlyToggle.init();
});

export default remoteOnlyToggle;
